import facebookLogo from 'images/sociallink_facebook.svg';
import instagramLogo from 'images/sociallink_instagram.svg';
import twitterLogo from 'images/sociallink_twitter.svg';
import youtubeLogo from 'images/sociallink_youtube.svg';
import whatsappLogo from 'images/sociallink_whatsapp.svg';
import yacopiniLogo from 'images/yacopini-logo-white.png';
import './Footer.scss';

const Header = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer__data">
        <div className="footer__data__image">
          <img src={yacopiniLogo} height="56" alt="Yacopini Mirai" />
        </div>
        <h4>Yacopini Mirai</h4>
        <p>San Martín Sur 600. Godoy Cruz, Mendoza.</p>
        <p>Av. Bartolomé Mitre 530, San Rafael, Mendoza.</p>
        <p>Paula Albarracín de Sarmiento 699, San Juan.</p>
      </div>
      <div className="footer__social">
        <a
          href="https://www.facebook.com/profile.php?id=61583755955687 "
          target="_blank"
          rel="noopener noreferrer"
          className="footer__social__link"
        >
          <img src={facebookLogo} alt="Facebook" />
        </a>
        <a
          href="https://www.instagram.com/yacopininissan/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__social__link footer__social__link-instagram"
        >
          <img src={instagramLogo} alt="Instagram" />
        </a>

        <a
          href="https://wa.me/5492616548107"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__social__link footer__social__link-whatsapp"
        >
          <img src={whatsappLogo} alt="Whatsapp" />
        </a>
      </div>
    </div>
  </footer>
);

export default Header;
